import { render, staticRenderFns } from "./KSeeMoreLess.vue?vue&type=template&id=1bf8b04a"
import script from "./KSeeMoreLess.vue?vue&type=script&lang=js"
export * from "./KSeeMoreLess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports